export const FUNDO_AMBIENTAL_HTML = `
<div class="fundo-ambiental-modal">
<img
  class="fundo-ambiental-modal__close"
  src="https://t.womtp.com/slider/c/Iberdrola/pt/main/create-satellite/modals/img/close.svg"
  alt="botão fechar"
/>

<picture class="fundo-ambiental-modal__banner-mask">
  <span class="fundo-ambiental-modal__banner-promo"
    >Reembolso até 85% do valor</span
  >
  <img
    class="fundo-ambiental-modal__banner"
    src="https://t.womtp.com/slider/c/Iberdrola/pt/main/create-satellite/modals/img/solar-panel.jpg"
    alt="painel solar"
  />
</picture>
<h2 class="fundo-ambiental-modal__heading">O Fundo Ambiental já abriu</h2>
<p class="fundo-ambiental-modal__tagline">
  Painéis Solares com reembolso até 85% do valor? Deixe-nos o seu contacto
  para saber mais.
</p>

<form
  id="fundo-ambiental-modal__form"
  class="fundo-ambiental-modal__form"
>
  <input class="wg-return" type="hidden" value="DCL_success" />
  <fieldset class="fundo-ambiental-modal__inputs-wrap">
    <div>
      <input
        name="name"
        class="fundo-ambiental-modal__input"
        type="text"
        placeholder="Nome"
      />
    </div>
    <div>
      <input
        name="phone"
        class="fundo-ambiental-modal__input"
        type="tel"
        placeholder="Telemóvel"
      />
    </div>
  </fieldset>
  <div>
    <div class="fundo-ambiental-modal__field-checkbox">
      <input
        name="policy"
        id="policy-checkbox"
        class="fundo-ambiental-modal__input-checkbox"
        type="checkbox"
        value="true"
      />
      <label
        class="fundo-ambiental-modal__field-label"
        for="policy-checkbox"
        >Declaro que sou maior de 18 anos, li e aceito a política de
        privacidade.
      </label>
    </div>
  </div>

  <button type="submit" class="fundo-ambiental-modal__submit">
    Liguem-me
  </button>
</form>
</div>
`
